import { clsx } from "clsx";
import { type PropsWithChildren } from "react";

type CategoriesLayoutProps = PropsWithChildren<{
  count: number;
}>;

export const CategoriesLayout = ({
  children,
  count
}: CategoriesLayoutProps) => {
  return (
    <div
      className={clsx("grid grid-cols-7 gap-1", {
        "!grid-cols-4": count <= 4 || count === 8,
        "!grid-cols-5": count === 5 || (count >= 9 && count <= 10),
        "!grid-cols-6": count === 6 || (count >= 11 && count <= 12)
      })}
    >
      {children}
    </div>
  );
};
